import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory, useLocation } from 'react-router-dom';
import translations from '../../translations/de';
import Paths from '../../constants/paths';
import Item from '../../components/Item';
import Input from '../../components/Input';
import Select from '../../components/Select';
import InputSeason from '../../components/InputSeason/InputSeason';
import parkingAPI from '../../api/parking';

// Per client: only full-season parking passes are created (no single game).
const NewParkingPass = ({ store }) => {
    const history = useHistory();
    const location = useLocation();
    const presetFieldId = location.state?.parkingFieldId ?? null;
    const presetFieldName = location.state?.parkingFieldName ?? null;

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [fields, setFields] = useState([]);
    const [parkingFieldId, setParkingFieldId] = useState(presetFieldId);
    const [seasonId, setSeasonId] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [contact, setContact] = useState({ first_name: '', last_name: '', email: '', phone: '' });

    useEffect(() => {
        !store.dataLoaded && store.setDataLoaded();
        parkingAPI
            .getFields()
            .then((res) => setFields(res.data))
            .catch(() => {});
    }, [store]);

    const backToField = () =>
        parkingFieldId
            ? history.push(Paths.PARKING_FIELD.replace(':field_id', parkingFieldId))
            : history.push(Paths.PARKING_FIELDS);

    const submit = () => {
        setError(null);
        if (!parkingFieldId) {
            setError(translations.required + ': ' + translations.parking_field);
            return;
        }
        if (!seasonId) {
            setError(translations.required + ': ' + translations.season);
            return;
        }
        const base = {
            type: 'full_season',
            parking_field_id: parkingFieldId,
            season_id: seasonId,
        };
        if (contact.first_name) base.first_name = contact.first_name;
        if (contact.last_name) base.last_name = contact.last_name;
        if (contact.email) base.email = contact.email;
        if (contact.phone) base.phone = contact.phone;

        setLoading(true);
        const action =
            Number(quantity) > 1
                ? store.createBulk({ ...base, quantity: Number(quantity) })
                : store.createPass(base);
        action
            .then(() => {
                setLoading(false);
                backToField();
            })
            .catch((err) => {
                setError(err);
                setLoading(false);
            });
    };

    const fieldOptions = fields.map((f) => ({ label: f.name, value: f.id }));

    return (
        <Item
            links={[{ path: Paths.PARKING_FIELDS, name: translations.parking_fields }]}
            name={`${translations.parking_passes} ${translations.create}`}
            itemModel={{}}
            edit={true}
            onSubmit={submit}
            onCancel={() => history.goBack()}
            error={error}
            loading={loading}
        >
            <div className="parking-new-form" style={{ maxWidth: '520px' }}>
                {presetFieldId ? (
                    <Input label={translations.parking_field} value={presetFieldName ?? ''} disabled />
                ) : (
                    <Select
                        label={translations.parking_field}
                        options={fieldOptions}
                        onChange={(e) => setParkingFieldId(e.value)}
                    />
                )}
                <InputSeason selectedSeason={seasonId} setSelectedSeason={setSeasonId} />
                <Input
                    label={translations.quantity}
                    type="number"
                    value={quantity}
                    onChange={(e) => setQuantity(e.target.value)}
                />
                <Input
                    label="Vorname"
                    value={contact.first_name}
                    onChange={(e) => setContact({ ...contact, first_name: e.target.value })}
                />
                <Input
                    label="Nachname"
                    value={contact.last_name}
                    onChange={(e) => setContact({ ...contact, last_name: e.target.value })}
                />
                <Input
                    label="Email"
                    value={contact.email}
                    onChange={(e) => setContact({ ...contact, email: e.target.value })}
                />
                <Input
                    label="Telefon"
                    value={contact.phone}
                    onChange={(e) => setContact({ ...contact, phone: e.target.value })}
                />
            </div>
        </Item>
    );
};

export default observer(NewParkingPass);
